/* Handles search behavior for standalone search results page */

import algoliasearch from 'algoliasearch/lite';
import instantsearch from 'instantsearch.js';
import { history } from 'instantsearch.js/es/lib/routers';
import aa from 'search-insights';
import { searchBox, hits, configure, stats, sortBy, pagination, index, refinementList, numericMenu, panel, hitsPerPage, clearRefinements } from 'instantsearch.js/es/widgets';
import { createInsightsMiddleware } from 'instantsearch.js/es/middlewares';
import Cookies from 'cookies-js';

aa('init', { appId: algoliaConfig.id, apiKey: algoliaConfig.key, useCookie: true });
let userToken = window.algoliaUserToken ? window.algoliaUserToken : Cookies.get('_ALGOLIA');
aa('setUserToken', userToken);

const insightsMiddleware = createInsightsMiddleware({
  insightsClient: aa
});

var ALLOWED_FOREIGN_PARAMS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
];
var foreignRouteState;
var paginationOptions = [
  { label: '9 per page', value: 9, default: true },
  { label: '15 per page', value: 15 },
  { label: '21 per page', value: 21 },
];
function statsOutput(data, type){
  var count;
  if (data.hasManyResults) {
    count = `${data.nbHits} ${type} results`;
  } else if (data.hasOneResult) {
    count = `1 ${type} result`;
  } else {
    count = `0 ${type} results`;
  }
  return `<h2>${count}</h2>`;
}
function jumpOutput(data, type, key){
  var count;
  if (data.hasManyResults) {
    count = `${data.nbHits} ${type} results`;
  } else if (data.hasOneResult) {
    count = `1 ${type} result`;
  } else {
    count = `0 ${type} results`;
  }
  return `<button class="ais-jump" data-target="#ais-${key}-stats">${count}</button>`;
}
function getTrackedUiState(uiState) {
  var trackedUiState = {};
  Object.keys(uiState).forEach(function(k) {
    if (k === 'configure' || k === 'query' || k === 'q') {
      return;
    }
    trackedUiState[k] = uiState[k];
  });
  return trackedUiState;
}

function singleIndex(indexName) {
  return {
    /**
    * `stateToRoute` method transforms the `uiState` object from InstantSearch
    * into an object that will then be serialized to construct the URL.
    */
    stateToRoute: function(uiState) {
      var route = getTrackedUiState(uiState[indexName] || {});
      route.q = uiState[indexName].query;
      return Object.assign({}, foreignRouteState, route);
    },

    /**
    * `routeToState` method transforms the route object into a `uiState` object
    * so that InstantSearch is initialized with the correct state from the
    * URL.
    */
    routeToState: function(routeState) {
      /**
      * Backup parameters from `routeState` into a different object
      * `foreignRouteState` so that we can re-inject them into the object
      * returned within `stateToRoute`.
      * This allows us to preserve the parameters specified in `ALLOWED_FOREIGN_PARAMS`
      * array.
      */
      if (!foreignRouteState) {
        foreignRouteState = ALLOWED_FOREIGN_PARAMS.reduce(function(acc, key) {
          acc[key] = routeState[key];
          return acc;
        }, {});
      }

      var state = {};
      state[indexName] = getTrackedUiState(routeState || {});
      state[indexName].query = routeState.q;
      return state;
    },
  };
}

const search = instantsearch({
  indexName: window.algoliaConfig.indices.products,
  searchClient: algoliasearch(window.algoliaConfig.id, window.algoliaConfig.key),
  routing: {
    router: history(),
    stateMapping: singleIndex(window.algoliaConfig.indices.products),
  }
});
search.use(insightsMiddleware);

/*
Holster Filters
*/
const filterHBrand = panel({
  hidden(options) {
    return options.results.nbHits === 0;
  },
  templates: {
    header: 'Brand',
  },
})(refinementList);

const filterHSeries = panel({
  hidden(options) {
    return options.results.nbHits === 0;
  },
  templates: {
    header: 'Series',
  },
})(refinementList);

const filterHHolsterType = panel({
  hidden(options) {
    return options.results.nbHits === 0;
  },
  templates: {
    header: 'Holster Type',
  },
})(refinementList);

const filterHCarryType = panel({
  hidden(options) {
    return options.results.nbHits === 0;
  },
  templates: {
    header: 'Carry Type',
  },
})(refinementList);

const filterHSecurityMechanism = panel({
  hidden(options) {
    return options.results.nbHits === 0;
  },
  templates: {
    header: 'Security Mechanism',
  },
})(refinementList);

const filterHColor = panel({
  hidden(options) {
    return options.results.nbHits === 0;
  },
  templates: {
    header: 'Color',
  },
})(refinementList);

const filterHFinish = panel({
  hidden(options) {
    return options.results.nbHits === 0;
  },
  templates: {
    header: 'Finish',
  },
})(refinementList);

const filterHMaterial = panel({
  hidden(options) {
    return options.results.nbHits === 0;
  },
  templates: {
    header: 'Material',
  },
})(refinementList);

const filterHPrice = panel({
  templates: {
    header: 'Price',
  },
})(numericMenu);

/*
Product Filters
*/
const filterBrand = panel({
  hidden(options) {
    return options.results.nbHits === 0;
  },
  templates: {
    header: 'Brand',
  },
})(refinementList);

const filterType = panel({
  hidden(options) {
    return options.results.nbHits === 0;
  },
  templates: {
    header: 'Type',
  },
})(refinementList);

const filterPrice = panel({
  templates: {
    header: 'Price',
  },
})(numericMenu);

search.addWidgets([
  configure({
    clickAnalytics: true,
  }),
  searchBox({
    container: '#ais-search',
    showSubmit: false,
    showReset: false,
    showLoadingIndicator: false,
    placeholder: 'Search'
  }),
  index({ indexName: window.algoliaConfig.indices.holsters }).addWidgets([
    configure({
      facetFilters: [
        'online_flag:1'
      ]
    }),
    hits({
      container: '#ais-h-hits',
      templates: {
        empty(results) {
          return `No results for <q>${results.query}</q>`;
        },
        item(hit, bindEvent){
          let _state = search.renderState[window.algoliaConfig.indices.products].searchBox; // using the products index since that's what's used in instantsearch({}) above when defining search
          var img = '';
          if( hit.thumbnail ){
            var thumbnail = hit.thumbnail.replace('.jpg','_283x250.jpg');
            img = `<img src="${thumbnail}" alt="">`;
          }
          // default price
          var price = hit.price;
          var priceHtml = '$' + window.helpers.numberWithCommas(price.toFixed(2));
          // parent products will have a 0 price
          if (!price) {
            // price_min might be 0 when a price isn't set on one of the children
            price = parseFloat(hit.price_max);
            // support price ranges making sure we have a non-zero min price
            if( parseFloat(hit.price_min) > 0 && hit.price_min !== hit.price_max){
              priceHtml = '$' +  window.helpers.numberWithCommas(parseFloat(hit.price_min).toFixed(2)) + ' &mdash; ' + '$' +  window.helpers.numberWithCommas(parseFloat(hit.price_max).toFixed(2));
            } else {
              priceHtml = '$' + window.helpers.numberWithCommas(price.toFixed(2));
            }
          }
          var url = window.helpers.algoliaHitUrl(hit, _state, window.algoliaConfig.indices.holsters );
          return `<a class="product-item" href="${url}" ${bindEvent('click', hit, 'Search Result Clicked')}>
              <div class="thumbnail">${img}</div>
              <div class="details">
                <div class="title">${instantsearch.highlight({ attribute: 'name', hit })}</div>
                <div class="price">${priceHtml}</div>
              </div>
            </a>`;
        }
      },
    }),
    stats({
      container: '#ais-h-stats',
      templates: {
        text(data) {
          return statsOutput(data, 'Holster');
        },
      }
    }),
    stats({
      container: '#ais-h-jump',
      templates: {
        text(data) {
          return jumpOutput(data, 'Holster', 'h');
        },
      }
    }),
    stats({
      container: '#ais-h-count',
      templates: {
        text(data) {
            return data.nbHits;
        },
      }
    }),
    sortBy({
      container: '#ais-h-sort-by',
      items: [
        { label: 'Most relevant', value: window.algoliaConfig.indices.holsters },
        { label: 'Price Low to High', value: window.algoliaConfig.indices.holsters + '_price_asc' },
        { label: 'Price High to Low', value: window.algoliaConfig.indices.holsters + '_price_desc' },
        { label: 'Model', value: window.algoliaConfig.indices.holsters + '_model_asc' },
      ],
    }),
    hitsPerPage({
      container: '#ais-h-hits-per-page',
      items: paginationOptions,
    }),
    pagination({
      container: '#ais-h-pagination',
      scrollTo: false,
    }),
    // filterHBrand({
    //   container: '#ais-h-refine-brand',
    //   attribute: 'brand',
    // }),
    // filterHSeries({
    //   container: '#ais-h-refine-series',
    //   attribute: 'series',
    //   limit: 5,
    //   showMore: true
    // }),
    filterHHolsterType({
      container: '#ais-h-refine-holster-type',
      attribute: 'holster_type',
      limit: 5,
      showMore: true
    }),
    filterHCarryType({
      container: '#ais-h-refine-carry-type',
      attribute: 'carry_type',
      limit: 5,
      showMore: true
    }),
    filterHSecurityMechanism({
      container: '#ais-h-refine-security-mechanism',
      attribute: 'security_mechanism',
      limit: 5,
      showMore: true
    }),
    filterHColor({
      container: '#ais-h-refine-color',
      attribute: 'color',
      limit: 5,
      showMore: true,
      showMoreLimit: 50
    }),
    filterHMaterial({
      container: '#ais-h-refine-material',
      attribute: 'material',
      limit: 5,
      showMore: true
    }),
    filterHFinish({
      container: '#ais-h-refine-finish',
      attribute: 'finish',
      limit: 5,
      showMore: true
    }),
    // filterHPrice({
    //   container: '#ais-h-refine-price',
    //   attribute: 'price',
    //   items: [
    //     { label: 'All' },
    //     { label: 'Less than $50', end: 50 },
    //     { label: 'Between $50 - $125', start: 50, end: 125 },
    //     { label: 'Between $125 - $200', start: 125, end: 200 },
    //     { label: 'More than $200', start: 200 },
    //   ],
    // }),
    clearRefinements({
      container: '#ais-h-clear-refinements',
      templates: {
        resetLabel() {
          return 'Clear filters' + window.app.btnBorder;
        },
      },
    })
  ]),
  index({ indexName: window.algoliaConfig.indices.products }).addWidgets([
    configure({
      facetFilters: 'product_type:-Holsters',
    }),
    hits({
      container: '#ais-p-hits',
      templates: {
        empty(results) {
          return `No results for <q>${results.query}</q>`;
        },
        item(hit, bindEvent){
          let _state = search.renderState[window.algoliaConfig.indices.products].searchBox;
          var img = '';
          if (hit.image) {
            var src = hit.image.replace('.jpg','_283x250.jpg');
            img = `<img src="${src}" alt="">`;
          }
          var price = window.helpers.numberWithCommas(hit.price.toFixed(2));
          var priceHtml = '$' + price;
          if (hit.variants_min_price !== hit.variants_max_price) {
            priceHtml = '$' +  window.helpers.numberWithCommas(hit.variants_min_price.toFixed(2)) + ' &mdash; ' + '$' +  window.helpers.numberWithCommas(hit.variants_max_price.toFixed(2));
          }
          // find a dealer products
          if (hit.price === 9999.99) {
            priceHtml = '';
          }
          var url = window.helpers.algoliaHitUrl(hit, _state, window.algoliaConfig.indices.products);
          return `<a class="product-item" href="${url}" ${bindEvent('click', hit, 'Search Result Clicked')}>
              <div class="thumbnail">${img}</div>
              <div class="details">
                <div class="title">${instantsearch.highlight({ attribute: 'title', hit })}</div>
                <div class="price">${priceHtml}</div>
              </div>
            </a>`;
        }
      },
    }),
    stats({
      container: '#ais-p-stats',
      templates: {
        text(data) {
          return statsOutput(data, 'Equipment');
        },
      }
    }),
    stats({
      container: '#ais-p-jump',
      templates: {
        text(data) {
          return jumpOutput(data, 'Equipment', 'p');
        },
      }
    }),
    stats({
        container: '#ais-p-count',
        templates: {
            text(data) {
                return data.nbHits;
            },
        }
    }),
    sortBy({
      container: '#ais-p-sort-by',
      items: [
        { label: 'Most relevant', value: window.algoliaConfig.indices.products },
        { label: 'Price Low to High', value: window.algoliaConfig.indices.products + '_price_asc' },
        { label: 'Price High to Low', value: window.algoliaConfig.indices.products + '_price_desc' },
      ],
    }),
    hitsPerPage({
      container: '#ais-p-hits-per-page',
      items: paginationOptions,
    }),
    pagination({
      container: '#ais-p-pagination',
      scrollTo: false,
    }),
    filterBrand({
      container: '#ais-p-refine-brand',
      attribute: 'vendor'
    }),
    filterType({
      container: '#ais-p-refine-type',
      attribute: 'product_type'
    }),
    filterPrice({
      container: '#ais-p-refine-price',
      attribute: 'price',
      items: [
        { label: 'All' },
        { label: 'Less than $50', end: 50 },
        { label: 'Between $50 - $100', start: 50, end: 100 },
        { label: 'More than $100', start: 100 },
      ],
      templates: {
        item: `
          <label class="{{cssClasses.label}}">
            <input
              type="radio"
              class="{{cssClasses.radio}}"
              name="p-{{attribute}}"
              {{#isRefined}} checked{{/isRefined}}
            />
            <span class="{{cssClasses.labelText}}">
              {{label}}
            </span>
          </label>`,
      }
    }),
    clearRefinements({
      container: '#ais-p-clear-refinements',
      templates: {
        resetLabel() {
          return 'Clear filters' + window.app.btnBorder;
        },
      },
    }),
  ]),
  index({ indexName: window.algoliaConfig.indices.articles }).addWidgets([
    hits({
      container: '#ais-a-hits',
      templates: {
        empty(results) {
          return `No article results for <q>${results.query}</q>`;
        },
        item(hit, bindEvent){
          return `<a class="article-result" href="${hit.permalink}" ${bindEvent('click', hit, 'Search Result Clicked')}>
              <div class="title">${instantsearch.highlight({ attribute: 'post_title', hit })}</div>
          </a>`;
        }
      },
    }),
    stats({
      container: '#ais-a-stats',
      templates: {
        text(data) {
          return statsOutput(data, 'Education');
        },
      }
    }),
    stats({
      container: '#ais-a-jump',
      templates: {
        text(data) {
          return jumpOutput(data, 'Education', 'a');
        },
      }
    }),
    stats({
        container: '#ais-a-count',
        templates: {
            text(data) {
                return data.nbHits;
            },
        }
    }),
    hitsPerPage({
      container: '#ais-a-hits-per-page',
      items: paginationOptions,
    }),
    pagination({
      container: '#ais-a-pagination',
      scrollTo: false,
    }),
  ]),
  index({ indexName: window.algoliaConfig.indices.pages }).addWidgets([
    hits({
      container: '#ais-pg-hits',
      templates: {
        empty(results) {
          return `No article results for <q>${results.query}</q>`;
        },
        item(hit, bindEvent){
          return `<a class="article-result" href="/pages/${hit.handle}" ${bindEvent('click', hit, 'Search Result Clicked')}>
              <div class="title">${instantsearch.highlight({ attribute: 'title', hit })}</div>
          </a>`;
        }
      },
    }),
    stats({
      container: '#ais-pg-stats',
      templates: {
        text(data) {
          return statsOutput(data, 'Page');
        },
      }
    }),
    stats({
      container: '#ais-pg-jump',
      templates: {
        text(data) {
          return jumpOutput(data, 'Page', 'a');
        },
      }
    }),
    stats({
        container: '#ais-pg-count',
        templates: {
            text(data) {
                return data.nbHits;
            },
        }
    }),
    hitsPerPage({
      container: '#ais-pg-hits-per-page',
      items: paginationOptions,
    }),
    pagination({
      container: '#ais-pg-pagination',
      scrollTo: false,
    }),
  ]),
  index({ indexName: window.algoliaConfig.indices.saves }).addWidgets([
    hits({
      container: '#ais-s-hits',
      templates: {
        empty(results) {
          return `No Saves Club results for <q>${results.query}</q>`;
        },
        item(hit, bindEvent){
          return `<a class="saves-club-result" href="${hit.permalink}" ${bindEvent('click', hit, 'Search Result Clicked')}>
              <div class="title">${instantsearch.highlight({ attribute: 'post_title', hit })}</div>
          </a>`;
        }
      },
    }),
    stats({
      container: '#ais-s-stats',
      templates: {
        text(data) {
          return statsOutput(data, 'Saves Club');
        },
      }
    }),
    stats({
      container: '#ais-s-jump',
      templates: {
        text(data) {
          return jumpOutput(data, 'Saves Club', 's');
        },
      }
    }),
    stats({
        container: '#ais-s-count',
        templates: {
            text(data) {
                return data.nbHits;
            },
        }
    }),
    hitsPerPage({
      container: '#ais-s-hits-per-page',
      items: paginationOptions,
    }),
    pagination({
      container: '#ais-s-pagination',
      scrollTo: false,
    }),
  ])
]);

search.on('render', () => {
    var $container = $('#results-container');
    // move no-result sections to the bottom of the page
    $('.results-type').each(function(){
        $(this)[0].dataset.count = $(this).find('.results-count').text();

        // rank holsters and equipment higher than other result types
        if ($(this).is('#h-results') || $(this).is('#p-results')) {
          $(this)[0].dataset.count = $(this)[0].dataset.count * 10;
        }
    });
    $container.find('.results-type').sort(function(a, b) {
        return +b.dataset.count - +a.dataset.count;
    })
    .appendTo($container);
});

search.start();

// algolia doesn't provide a open class in their js
$b.on('click', '.ais-RefinementList-showMore', function(e){
  $(this).toggleClass('is-open');
});
// regular links cause change states, so fake a normal link behavior
$b.on('click', '.ais-jump', function(e){
  e.preventDefault();
  var $target = $($(this).data('target'));
  $('html, body').animate({
		scrollTop: $target.offset().top - $('#site-header').outerHeight()
	}, 1000);
});

$b.on('click', '.panel-toggle', function(e){
  e.preventDefault();
  $(this).closest('.search-filter-panels').toggleClass('is-open');
});